import styled, { css } from 'styled-components';
import {
  SYS_SPACE_FIXED_50,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_RELATIVE_MD,
  SYS_COLOR_SURFACE_SCRIM_DEFAULT_DARK,
  SYS_SPACE_FIXED_150,
} from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '@oneaudi/vtp-shared';
import {
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
  SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_FILL_DARK,
} from '@oneaudi/unified-web-alpha-common';

export const LinkButtonContainer = styled.div`
  padding: 0 0;
`;

export const AlphaOnlyWrapper = styled.div`
  padding: ${SYS_SPACE_RELATIVE_MD};
  & p {
    margin: 0;
  }
`;

export const ConsumptionEmissionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${dynamicStylingHelper(SYS_SPACE_FIXED_100, '')};
  align-self: stretch;
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  row-gap: 10px;
  ${dynamicStylingHelper(`margin-bottom: ${SYS_SPACE_FIXED_200}`)};
  & a {
    ${dynamicStyling({
      alpha: `
        background: ${SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_FILL_DARK};
        color: ${SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT}
    `,
    })};
  }
`;

export const FavoritesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: ${dynamicStylingHelper(SYS_SPACE_FIXED_50, SYS_SPACE_FIXED_100)};
`;

export const FavoritesOverlay = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${SYS_COLOR_SURFACE_SCRIM_DEFAULT_DARK};

  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

const GridButtonStyles = css`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  gap: ${SYS_SPACE_FIXED_150};

  button {
    width: 100%;
  }
`;

export const GridButtonContainer = styled.div`
  ${GridButtonStyles}
`;
